import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { v4 as uuidv4 } from 'uuid'

import { confirm } from "components/Confirmation";
import IconButton from "components/IconButton";

import cruzamentoService from "services/CruzamentoService";
import ModalAnexar from "./ModalAnexar";
import anexoCruzamentoService from "services/AnexoCruzamentoService";
import AppContext from "AppContext";

export default function Anexos({ edit, idCruzamento }) {
  const [items, setItems] = useState([])
  const [anexarConfig, setAnexarConfig] = useState(null)
  const { state } = useContext(AppContext)

  const carregar = async () => {
    const res = await anexoCruzamentoService.get(idCruzamento)
    if (res.success) {
      setItems(res.data)
    }
  }

  useEffect(() => {
    if (idCruzamento) {
      carregar()
    }
  }, [idCruzamento])

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await anexoCruzamentoService.delete(item.id)
          if (res.success) {
            carregar()
            toast("Anexo excluído")
          } else {
            toast("Erro ao excluir o anexo")
          }
        } catch (ex) {
          toast("Erro ao excluir o anexo")
        }
      }
    })
  }

  const handleDownload = async (e, item) => {
    e.preventDefault()

    try {
      const signedUrl = await anexoCruzamentoService.download(item.id)
      window.open(signedUrl, '_blank', 'noopener,noreferrer')
    } catch (ex) {
      toast("Erro ao baixar o anexo")
    }
  }

  return (
    <>
      {edit && (
        <div className="d-flex flex-row justify-content-end align-items-center pb-4">
          <Button type="button" color="primary" onClick={() => setAnexarConfig({ idCruzamento })}>Anexar</Button>
        </div>
      )}

      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Tipo de Anexo</th>
            <th scope="col">Nome Arquivo</th>
            <th scope="col" style={{ width: 100 }}></th>
          </tr>
        </thead>
        <tbody>
          {items.length == 0 && (
            <tr>
              <td colSpan={2} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {items.map(el => (
            <tr key={el.id}>
              <td>{el.tipoAnexo?.descricao}</td>
              <td>{el.arquivo.nomeArquivo}</td>
              <td className="d-flex flex-row gap-5px justify-content-end">
                <IconButton alt="Baixar" iconClass="bi-download" onClick={(e) => handleDownload(e, el)} />
                {edit && (
                  <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ModalAnexar
        config={anexarConfig}
        onChange={() => carregar()}
        onClose={() => setAnexarConfig(null)}
      />

    </>
  )
}